<template>
  <div>
    <b-row>
      <b-col cols="12">
        <counters />
      </b-col>
      <b-col
        cols="12"
      >
        <usage-card />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import Counters from '@/views/Dashboard/Counters.vue'
import UsageCard from '@/views/Dashboard/UsageCard.vue'

export default {
  name: 'Manager',
  components: {
    BRow,
    BCol,
    Counters,
    UsageCard,
  },
  created() {
    this.getDashboard()
  },
  methods: {
    getDashboard() {
      this.$store.dispatch('dashboard/getDashboard')
    },
  },
}
</script>
